import * as THREE from 'three';


export const PRODUCTS = [
  {
    id: 'original',
    name: 'Original',
    model: 'dove_blue.glb'
  },
  {
    id: 'body',
    name: 'Body',
    model: 'dove_pink.glb'
  },
];


export const SATELLITE_ANIMATIONS = {
  'pink_bg': { effect: 'fadeIn', delay: 0, duration: 800 },
  'pink_header': { effect: 'fadeInUp', delay: 400, duration: 800 },
  'pink_new_label': { effect: 'fadeInUp', delay: 600, duration: 800 },
  'pink_panel_right_a': { effect: 'fadeInUp', delay: 800, duration: 800 },
  'pink_panel_right_b': { effect: 'fadeInUp', delay: 1000, duration: 800 },
  'pink_para_todo_el_cuerpo': { effect: 'fadeInUp', delay: 1200, duration: 800 },
  'pink_hace_click': { effect: 'fadeInUp', delay: 1400, duration: 800 },
  'pink_panel_left_a': { effect: 'fadeInUp', delay: 1600, duration: 800 }
};

export const SATELITE_OBJECTS = [
  {
    id: 'original',
    model: 'dove_pink_satellite.glb',
    elements: []
  },
  {
    id: 'body',
    model: 'dove_pink_satellite.glb',
    elements: []
  }
];


export const animateProductToPosition = (product, finalPosition, duration = 800) => {
  const startPosition = { x: 0, y: 0.1, z: 0 };
  const startTime = Date.now();

  const trailObjects = [];
  const trailCount = 4;

  for (let i = 0; i < trailCount; i++) {
    const trailObject = product.clone();
    trailObject.scale.copy(product.scale);
    trailObject.position.copy(product.position);

    trailObject.traverse((child) => {
      if (child.isMesh && child.material) {
        const materials = Array.isArray(child.material) ? child.material : [child.material];
        materials.forEach((material) => {
          const trailMaterial = material.clone();
          trailMaterial.transparent = true;

          if (material.transparent && material.opacity < 1) {
            trailMaterial.opacity = material.opacity * (1 - i / trailCount) * 0.08;
            trailMaterial.depthWrite = false;
            trailMaterial.blending = THREE.AdditiveBlending;
          } else {
            trailMaterial.opacity = (1 - i / trailCount) * 0.15;
            trailMaterial.depthWrite = false;
          }

          child.material = trailMaterial;
        });
      }
    });

    trailObject.scale.multiplyScalar(1 - (i * 0.02));
    trailObjects.push(trailObject);
    product.parent.add(trailObject);
  }

  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuart = 1 - Math.pow(1 - progress, 4);

    const newX = startPosition.x + (finalPosition.x - startPosition.x) * easeOutQuart;
    const newY = startPosition.y + (finalPosition.y - startPosition.y) * easeOutQuart;
    const newZ = startPosition.z + (finalPosition.z - startPosition.z) * easeOutQuart;

    product.position.set(newX, newY, newZ);

    trailObjects.forEach((trailObject, index) => {
      const lag = (index + 1) * 0.08;
      const trailProgress = Math.max(0, progress - lag);
      const trailEase = 1 - Math.pow(1 - trailProgress, 4);

      const trailX = startPosition.x + (finalPosition.x - startPosition.x) * trailEase;
      const trailY = startPosition.y + (finalPosition.y - startPosition.y) * trailEase;
      const trailZ = startPosition.z + (finalPosition.z - startPosition.z) * trailEase;

      trailObject.position.set(trailX, trailY, trailZ);
    });

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      trailObjects.forEach(trailObject => {
        product.parent.remove(trailObject);
      });

      fadeInParaTusAxilas(product);
      fadeInForAllTheBody(product);

    }
  };

  animate();
};

export const animateProductToCenter = (product, onComplete, duration = 600) => {
  const startPosition = product.position.clone();
  const centerPosition = { x: 0, y: 0.1, z: 0 };
  const startTime = Date.now();

  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuart = 1 - Math.pow(1 - progress, 4);

    const newX = startPosition.x + (centerPosition.x - startPosition.x) * easeOutQuart;
    const newY = startPosition.y + (centerPosition.y - startPosition.y) * easeOutQuart;
    const newZ = startPosition.z + (centerPosition.z - startPosition.z) * easeOutQuart;

    product.position.set(newX, newY, newZ);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      if (onComplete) onComplete();
    }
  };

  animate();
};

export const animateOriginalProductUp = (product, duration = 600) => {
  const startPosition = product.position.clone();
  const upPosition = {
    x: startPosition.x,
    y: startPosition.y + 0.15,
    z: startPosition.z
  };
  const startTime = Date.now();

  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuart = 1 - Math.pow(1 - progress, 4);

    const newX = startPosition.x + (upPosition.x - startPosition.x) * easeOutQuart;
    const newY = startPosition.y + (upPosition.y - startPosition.y) * easeOutQuart;
    const newZ = startPosition.z + (upPosition.z - startPosition.z) * easeOutQuart;

    product.position.set(newX, newY, newZ);

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  };

  animate();
};

export const animateOriginalProductOut = (product, onComplete, duration = 800) => {
  const startPosition = product.position.clone();
  const startOpacity = 1;
  const backPosition = {
    x: startPosition.x,
    y: startPosition.y + 0.3,
    z: startPosition.z
  };
  const startTime = Date.now();

  product.traverse((child) => {
    if (child.isMesh && child.material) {
      const materials = Array.isArray(child.material) ? child.material : [child.material];
      materials.forEach((material) => {
        if (!material.transparent) {
          material.transparent = true;
          material.needsUpdate = true;
        }
      });
    }
  });

  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuart = 1 - Math.pow(1 - progress, 4);

    const newX = startPosition.x + (backPosition.x - startPosition.x) * easeOutQuart;
    const newY = startPosition.y + (backPosition.y - startPosition.y) * easeOutQuart;
    const newZ = startPosition.z + (backPosition.z - startPosition.z) * easeOutQuart;

    product.position.set(newX, newY, newZ);

    const newOpacity = startOpacity * (1 - progress);
    product.traverse((child) => {
      if (child.isMesh && child.material) {
        const materials = Array.isArray(child.material) ? child.material : [child.material];
        materials.forEach((material) => {
          material.opacity = newOpacity;
        });
      }
    });

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      product.visible = false;
      if (onComplete) onComplete();
    }
  };

  animate();
};

export const fadeInParaTusAxilas = (product, duration = 1000) => {
  const paraTusAxilasMesh = product.children.find(child =>
    child.userData && child.userData.isParaTusAxilas
  );

  if (!paraTusAxilasMesh) {
    product.traverse((child) => {
      if (child.isMesh && child.name === 'para_tus_axilas') {
        fadeInMesh(child, duration);
        return;
      }
    });
    return;
  }

  fadeInMesh(paraTusAxilasMesh, duration);
};

export const fadeInForAllTheBody = (product, duration = 1000) => {
  const forAllTheBodyMesh = product.children.find(child =>
    child.userData && child.userData.isForAllTheBody
  );

  if (!forAllTheBodyMesh) {
    product.traverse((child) => {
      if (child.isMesh && child.name === 'for_all_the_body') {
        fadeInMesh(child, duration);
        return;
      }
    });
    return;
  }

  fadeInMesh(forAllTheBodyMesh, duration);
};

export const fadeInMesh = (mesh, duration) => {

  mesh.visible = true;

  if (mesh.material) {
    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    materials.forEach((material) => {
      material.transparent = true;
      material.opacity = 0;
      material.needsUpdate = true;
    });
  }

  const startTime = Date.now();

  const animate = () => {
    const elapsed = Date.now() - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeOutQuart = 1 - Math.pow(1 - progress, 4);
    const opacity = easeOutQuart;

    if (mesh.material) {
      const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
      materials.forEach((material) => {
        material.opacity = opacity;
      });
    }

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  };

  animate();
};

export const startSubmeshSpin = (product, submeshNames, speed = 0.02) => {
  const spinningMeshes = [];
  
  // Handle both single string and array of strings
  const meshNames = Array.isArray(submeshNames) ? submeshNames : [submeshNames];
  
  product.traverse((child) => {
    if (child.isMesh && meshNames.includes(child.name)) {
      spinningMeshes.push(child);
    }
  });

  if (spinningMeshes.length === 0) {
    console.log(`No submeshes found for names: ${meshNames.join(', ')}`);
    return;
  }

  spinningMeshes.forEach(mesh => {
    // Store original rotation if not already stored
    if (!mesh.userData.originalRotation) {
      mesh.userData.originalRotation = mesh.rotation.clone();
    }

    // Mark as spinning and store animation function
    mesh.userData.isSpinning = true;
    mesh.userData.spinSpeed = speed;
  });

  const spin = () => {
    let anyStillSpinning = false;
    
    spinningMeshes.forEach(mesh => {
      if (mesh.userData.isSpinning) {
        mesh.rotation.y += speed;
        anyStillSpinning = true;
      }
    });
    
    if (anyStillSpinning) {
      requestAnimationFrame(spin);
    }
  };

  spin();
};

export const stopSubmeshSpin = (product, submeshNames) => {
  // Handle both single string and array of strings
  const meshNames = Array.isArray(submeshNames) ? submeshNames : [submeshNames];
  
  product.traverse((child) => {
    if (child.isMesh && meshNames.includes(child.name) && child.userData.isSpinning) {
      child.userData.isSpinning = false;
      
      if (child.userData.spinAnimationId) {
        cancelAnimationFrame(child.userData.spinAnimationId);
        child.userData.spinAnimationId = null;
      }

      // Restore original rotation
      if (child.userData.originalRotation) {
        child.rotation.copy(child.userData.originalRotation);
      }
    }
  });
};

export const animateSatelliteMesh = (mesh, animationConfig, anchorIndex = null, addPendingTimeout, removePendingTimeout, anchors = null) => {
  const { effect, delay, duration } = animationConfig;

  const timeoutId = setTimeout(() => {
    removePendingTimeout(timeoutId);

    if (anchorIndex !== null && anchors && !anchors[anchorIndex].visible) {
      return;
    }

    const originalPosition = mesh.position.clone();
    const originalScale = mesh.scale.clone();
    const originalRotation = mesh.rotation.clone();

    if (!mesh.userData.originalMaterial) {
      mesh.userData.originalMaterial = mesh.material;
      mesh.material = mesh.material.clone();
    }

    switch (effect) {
      case 'fadeIn':
        mesh.material.opacity = 0;
        break;
      case 'fadeInUp':
        mesh.material.opacity = 0;
        mesh.position.y -= 0.2;
        break;
      case 'fadeInLeft':
        mesh.material.opacity = 0;
        mesh.position.x -= 0.3;
        break;
      case 'fadeInRight':
        mesh.material.opacity = 0;
        mesh.position.x += 0.3;
        break;
      case 'fadeInDown':
        mesh.material.opacity = 0;
        mesh.position.y += 0.2;
        break;
      case 'fadeInScale':
        mesh.material.opacity = 0;
        mesh.scale.setScalar(0);
        break;
      case 'fadeInRotate':
        mesh.material.opacity = 0;
        mesh.rotation.z = Math.PI;
        break;
      case 'fadeInBounce':
        mesh.material.opacity = 0;
        mesh.scale.setScalar(0.1);
        break;
      case 'fadeInSlide':
        mesh.material.opacity = 0;
        mesh.position.z -= 0.5;
        break;
    }

    mesh.material.transparent = true;
    mesh.material.depthWrite = false;
    mesh.material.alphaTest = 0.001;
    mesh.renderOrder = mesh.position.z * 1000;
    mesh.visible = true;

    const startTime = Date.now();
    const animate = () => {
      if (anchorIndex !== null && anchors && !anchors[anchorIndex].visible) {
        mesh.userData.animationId = null;
        return;
      }

      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);

      switch (effect) {
        case 'fadeIn':
          mesh.material.opacity = progress;
          break;
        case 'fadeInUp':
          mesh.material.opacity = progress;
          mesh.position.y = originalPosition.y - 0.2 + (0.2 * easeOut);
          break;
        case 'fadeInLeft':
          mesh.material.opacity = progress;
          mesh.position.x = originalPosition.x - 0.3 + (0.3 * easeOut);
          break;
        case 'fadeInRight':
          mesh.material.opacity = progress;
          mesh.position.x = originalPosition.x + 0.3 - (0.3 * easeOut);
          break;
        case 'fadeInDown':
          mesh.material.opacity = progress;
          mesh.position.y = originalPosition.y + 0.2 - (0.2 * easeOut);
          break;
        case 'fadeInScale':
          mesh.material.opacity = progress;
          const scale = easeOut * originalScale.x;
          mesh.scale.set(scale, scale, scale);
          break;
        case 'fadeInRotate':
          mesh.material.opacity = progress;
          mesh.rotation.z = Math.PI - (Math.PI * easeOut);
          break;
        case 'fadeInBounce':
          mesh.material.opacity = progress;
          const bounceScale = 0.1 + (originalScale.x - 0.1) * easeOut * (1 + 0.3 * Math.sin(progress * Math.PI * 3));
          mesh.scale.setScalar(bounceScale);
          break;
        case 'fadeInSlide':
          mesh.material.opacity = progress;
          mesh.position.z = originalPosition.z - 0.5 + (0.5 * easeOut);
          break;
      }

      if (progress < 1) {
        mesh.userData.animationId = requestAnimationFrame(animate);
      } else {
        mesh.position.copy(originalPosition);
        mesh.scale.copy(originalScale);
        mesh.rotation.copy(originalRotation);
        mesh.material.opacity = 1;
        mesh.material.depthWrite = true;
        mesh.userData.animationId = null;
      }
    };

    animate();
  }, delay);
  addPendingTimeout(timeoutId);
};


export const disposeThreeObjects = (object) => {
  if (!object) return;

  if (object.traverse) {
    object.traverse((child) => {
      if (child.isMesh) {
        if (child.geometry) {
          child.geometry.dispose();
        }
        if (child.material) {
          const materials = Array.isArray(child.material) ? child.material : [child.material];
          materials.forEach((material) => {
            if (material.map) material.map.dispose();
            if (material.normalMap) material.normalMap.dispose();
            if (material.roughnessMap) material.roughnessMap.dispose();
            if (material.metalnessMap) material.metalnessMap.dispose();
            if (material.emissiveMap) material.emissiveMap.dispose();
            material.dispose();
          });
        }
      }
    });
  }
};
